import { Component, HostBinding, Input } from '@angular/core'

@Component({
    selector: 'mg-section',
    templateUrl: './section.component.html',
    styleUrls: ['./section.component.scss'],
})
export class SectionComponent {
    @Input() backgroundImage: string

    @HostBinding('style.background-image')
    @HostBinding('class._has_image')
    get backgroundImageProperty() {
        return this.backgroundImage ? `url(${this.backgroundImage})` : false
    }
}
